import { Platform } from "react-native";
import {
	type Environment,
	type GraphQLTaggedNode,
	type Variables,
	fetchQuery,
} from "react-relay";

import * as SentryReact from "@sentry/react";
import * as SentryNative from "@sentry/react-native";

const isWeb = Platform.OS === "web";
type GraphQLQueryParams = {
	params?: {
		name?: string;
		operationKind?: string;
		cacheID?: string;
		id?: string | null;
		metadata?: Record<string, unknown>;
		text?: string;
	};
};
const getSentryInstance = () => {
	if (isWeb) {
		return SentryReact;
	}
	return SentryNative;
};
export const logApiErrors = (
	query: GraphQLTaggedNode,
	error: unknown,
	variables?: Variables,
) => {
	const captureException = getSentryInstance().captureException;
	const err = error instanceof Error ? error : new Error(String(error));
	// biome-ignore lint/suspicious/noExplicitAny: sentry scope expects any
	captureException(err, (scope: any) => {
		scope.setExtras({
			serverError: error,
			queryName: (query as GraphQLQueryParams)?.params?.name,
			variables,
		});
		return scope;
	});
};
const fetchData = async (
	relayEnv: Environment,
	query: GraphQLTaggedNode,
	variables?: Variables,
) => {
	const promise = new Promise((resolve, reject) => {
		fetchQuery(relayEnv, query, variables || {}).subscribe({
			next: (data) => {
				resolve(data);
			},
			error: (err: unknown) => {
				logApiErrors(query, err, variables);
				reject(err);
			},
		});
	});
	return promise;
};

export { fetchData };
